module.exports = __webpack_public_path__ + "assets/search-not-found.c2800234.svg";